import request from '@/utils/request'

// 获取验证码
export function GetValideCode(data) {
  return request({
    url: 'front/MemberWeb/GetValideCode',
    method: 'post',
    data
  })
}

// 登录账号
export function LoginMember(data) {
  return request({
    url: 'front/MemberWeb/LoginMember',
    method: 'post',
    data
  })
}

// 注册账号
export function RegisterMember(data) {
  return request({
    url: 'front/MemberWeb/RegisterMember',
    method: 'post',
    data
  })
}

// 注册账号
export function RegisterByEmail(data) {
  return request({
    url: 'front/MemberWeb/RegisterByEmail',
    method: 'post',
    data
  })
}

// 国安注册账号
export function RegisterByGuoAn(data) {
  return request({
    url: 'front/MemberWeb/RegisterByGuoAn',
    method: 'post',
    data
  })
}


// 网站用户登录（邮箱无密码登录）
export function LoginMemberByEmail(data) {
  return request({
    url: 'front/MemberWeb/LoginMemberByEmail',
    method: 'post',
    data
  })
}


// 网站用户登录（无验证码）
export function LoginMemberNoCode(data) {
  return request({
    url: 'front/MemberWeb/LoginMemberNoCode',
    method: 'post',
    data
  })
}

// 获取用户信息
export function GetMemberInfo(data) {
  return request({
    url: 'front/MemberWeb/GetMemberInfo',
    method: 'post',
    data
  })
}


// 更新用户信息
export function UpdateMember(data) {
  return request({
    url: 'front/MemberWeb/UpdateMember',
    method: 'post',
    data
  })
}


// 获取客户来源列表
export function GetMemberSourceList(data) {
  return request({
    url: 'front/MemberWeb/GetMemberSourceList',
    method: 'post',
    data
  })
}

// 获取业务员列表
export function GetUserList(data) {
  return request({
    url: 'front/MemberWeb/GetUserList',
    method: 'post',
    data
  })
}

// 根据邮箱验证码修改密码
export function UpdatePasswordByEmail(data) {
  return request({
    url: 'front/MemberWeb/UpdatePasswordByEmail',
    method: 'post',
    data
  })
}

// 获取邮件验证码
export function GetEmailValideCode(data) {
  return request({
    url: 'front/MemberWeb/GetEmailValideCode',
    method: 'post',
    data
  })
}

// 验证邮箱
export function VerifyEmail(data) {
  return request({
    url: 'front/MemberWeb/VerifyEmail',
    method: 'post',
    data
  })
}

// 用户验证通过
export function VerifyMember(data) {
  return request({
    url: 'front/MemberWeb/VerifyMember',
    method: 'post',
    data
  })
}

// 用户留言
export function Message(data) {
  return request({
    url: 'front/MemberWeb/Message',
    method: 'post',
    data
  })
}

// 判断用户名是否存在
export function IsExistUserAccount(data) {
  return request({
    url: 'front/MemberWeb/IsExistUserAccount',
    method: 'post',
    data
  })
}

// 网站用户登录（邮箱密码登录无验证码）
export function LoginMemberByEmailNoValideCode(data) {
  return request({
    url: 'front/MemberWeb/LoginMemberByEmailNoValideCode',
    method: 'post',
    data
  })
}

// 网站用户登录
export function LoginMemberMemberWeb(data) {
  return request({
    url: 'front/MemberWeb/LoginMember',
    method: 'post',
    data
  })
}


// 判断参数是否存在
export function IsExist(data) {
  return request({
    url: 'front/MemberWeb/IsExist',
    method: 'post',
    data
  })
}

// 南通拇指登录
export function LoginMemberByMuZhi(data) {
  return request({
    url: 'front/MemberWeb/LoginMemberByMuZhi',
    method: 'post',
    data
  })
}

// 南通拇指注册
export function RegisterMemberByMuZhi(data) {
  return request({
    url: 'front/MemberWeb/RegisterMemberByMuZhi',
    method: 'post',
    data
  })
}

// 重置密码
export function ResetPassword(data) {
  return request({
    url: 'front/MemberWeb/ResetPassword',
    method: 'post',
    data
  })
}


